import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { completeLogin } from "@/api/session";
export default function OAuthCallback() {
  const [error, setError] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    let active = true;
    void completeLogin(location.search)
      .then((next) => {
        if (active) navigate(next, { replace: true });
      })
      .catch((cause: unknown) => {
        if (active) setError(cause instanceof Error ? cause.message : "Sign in failed");
      });
    return () => {
      active = false;
    };
  }, [navigate]);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      {error ? (
        <>
          <p role="alert">{error}</p>
          <Link to="/login">Return to sign in</Link>
        </>
      ) : (
        <p>Completing sign in…</p>
      )}
    </div>
  );
}
